// extracted by mini-css-extract-plugin
export default {"container":"M3q21","transform-card":"YwmKX","content":"bs6yO","content--no-offset":"Fv7Rr"};